import './cart.js';
import CookiesView from './views/CookiesView';
import Cart from './Cart';
import SVGInject from '../../modules/media/svg/theme/js/SVGInject';
import Spinner from './utils/Spinner';
import Icons from './utils/Icons';
import InfoBox from '../../modules/website/infobox/theme/js/InfoBox';
import MobileBox from './utils/MobileBox';
import PrivatePolicy from './utils/PrivatePolicy';

class Site {
	public static CookiesView = CookiesView;
	public static Cart = Cart;
	public static InfoBox = InfoBox;

	public static initProducts2($uid: JQuery): void {
		const $items = $('.products2__item', $uid);

		$items.each((ix, el) => {
			const $item = $(el);
			const $input = $('.products2__quantity', $item);

			const id: number = parseInt($item.data('id'));

			const updateFunc = (val: number) => {
				$item.addClass('products2__item--updating');

				Cart.setProductQuantity(id, val, () => {
					Cart.update(() => {
						$item.removeClass('products2__item--updating');
					});
				});
			};

			(<any> $input).qSpinner({
				min: 0,

				onLazySpin: (e, val) => {
					updateFunc(val);
				}
			});
		});
	}

	private static showFreshmail(): void {
		const key = 'freshpp';
		const time = 20;

		let $body = $('body');

		if ($body.hasClass('body--userlogged')) {
			return;
		}

		let freshcount = localStorage.getItem(key) != null ? parseInt(localStorage.getItem(key)) : 0;

    	if (freshcount >= 3) {
			return;
		}

		setTimeout(() => {
			let $div = $(`
				<div id="fm-pu-container" style="position: fixed; width: 100%; height: 100%; left: 0; top: 0; z-index: 999999; display: none; align-items: center;"><script>var container = document.getElementById('fm-pu-container');function hide(){container.style.display = 'none'; document.removeEventListener('mouseout', showPopup);} function showPopup(e){if(e.clientY <= 0){container.style.display = 'flex';}} var fmFCFwpkr6gij9l=function(e){if(e.data.type == 'resize'){ var iframe=document.getElementById('fm-fc-f-wpkr6gij9l');iframe.style.minHeight=e.data.size+'px';if(window.innerHeight<iframe.offsetHeight){container.style.cssText+='overflow:auto;align-items:flex-start;-webkit-overflow-scrolling:touch';}}else if(e.data.type == 'hide'){hide();}else if(e.data.type == 'timeout'){setTimeout(function(){container.style.display='flex';}, e.data.time * 1000 );}else if(e.data.type == 'onexit'){document.addEventListener('mouseout',showPopup)}else if(e.data.type=='setBackground'){container.style.background=e.data.background;}};window.addEventListener?addEventListener('message',fmFCFwpkr6gij9l,!1):attachEvent('onmessage',fmFCFwpkr6gij9l);container.addEventListener("click", hide);</script><iframe id="fm-fc-f-wpkr6gij9l" src="https://forms.freshmail.io/f/62l36jrvdm/wpkr6gij9l/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" style="min-height: 369px"></iframe></div>
			`);

			freshcount++;
			localStorage.setItem(key, freshcount.toString());

			$div.appendTo($body);
		}, time * 1000);
	}

	public static evalJs(): void {
        (<any> window)._js = (h: () => void) => {
            h();
        };

        let js = (<any> window)._jslist;

        $.each(js, (k, v) => {
            v();
        });
	}

	public static initHtml(): void {
		this.showFreshmail();

		PrivatePolicy.initCookieConsent();

		const $header = $('.header');
		const $mobilebutton = $('.header__mobile-button', $header);

		const mb = new MobileBox();

		$mobilebutton.on('click', (e) => {
			mb.open();
		});
	}

	public static init(): void {
		(<any> window).Site = Site;

		$(() => {
			this.initHtml();
		});
	}
}

(function($) {
	(<any> $.fn).ajaxUpdate=function(url, data, options) {
		var $this=$(this);

		var options=$.extend({

		}, options);

		$.post(url, data, function(d) {
			$this.replaceWith(d);
			$this.trigger('onload');
		});
	};

	(<any> $.fn).ajaxLoader=function() {
		var $this=$(this);
		$('<div class="ajaxloader">').hide().fadeIn(100).appendTo($this);
	};

	Spinner.init();

	(<any> $.fn).switchViewer=function() {
		var $this=$(this);

		$this.find('.switchviewer').each(function() {
			var $view=$(this);
			var $input=$this.find(':input[name="' + $view.data('input') + '"]');

			var reversed=$view.data('reversed');

			if (reversed ? $input.is(':checked') : !$input.is(':checked'))
				$view.hide();

			$input.change(function() {
				if (reversed ? !$input.is(':checked') : $input.is(':checked')) {
					$view.slideDown();
				} else {
					$view.slideUp();
				}
			});
		});

		return $this;
	};

	function initHomeTimer() {
		var $jstimer = $('.js-hometimer');
		var $timer = $('.hometimer__timer', $jstimer);

		if ($timer.length == 0) {
			return;
		}

		var $time_hour = $('<span class="hometimer__hour">').appendTo($timer);
		var $time_colon = $('<span class="hometimer__colon">:<span>').appendTo($timer);
		var $time_minute = $('<span class="hometimer__minute">').appendTo($timer);

		var timer = null;

		var now = new Date();
		var stop = new Date(
			now.getFullYear()
			+ '-' + (now.getMonth() + 1)
			+ '-' +	(now.getDate())
			+ ' 13:00:00'
		);

		var ts_stop = Math.round(stop.getTime() / 1000);

		function numFormat(num) {
			if (('' + num).length == 1) {
				return '0' + num;
			} else {
				return num;
			}
		}

		function hideTimer() {
			window.clearTimeout(timer);
			timer = null;

			$timer.hide();
		}

		function updateTimer() {
			var ts_now = Math.round(new Date().getTime() / 1000);
			var ts = ts_stop - ts_now;

			if (ts < 0) {
				hideTimer();

				return null;
			}

			if ($time_colon.hasClass('hometimer__colon--tick')) {
				$time_colon.removeClass('hometimer__colon--tick');
			} else {
				$time_colon.addClass('hometimer__colon--tick');
			}

			var minutes = Math.ceil(ts / 60);
			var hours = Math.floor(minutes / 60);

			$time_hour.text(numFormat(hours));
			$time_minute.text(numFormat(minutes % 60));
		}

		timer = window.setInterval(function() {
			updateTimer();
		}, 500);

		updateTimer();

		$jstimer.addClass('hometimer--inited');
	}

	(<any> window).updateElements = function($parent) {
		(<any> $('.lightbox, .fancybox, a[rel="lightbox"], #vproduct .imginfo figure a', $parent)).fancybox({
			titlePosition: 'over'
		});

		SVGInject.discover($parent);
		Icons.discover($parent);
	}


	$(document).ready(function() {
		var $body = $('body');

		(<any> window).updateElements();

		function updateLayout() {
			var top = $(document).scrollTop();

			$body.toggleClass('body--no-float', top == 0);
			$body.toggleClass('body--float', top > 0);
		}

		function initMenu($children) {
			function open($item) {
				$item.data('opened', 1);

				const wx = $(window).width();
				const ileft = $item.offset().left;

				$item.children('ul').each(function () {
					const $el = $(this);

					const elwidth = $el.width();

					const pos = {
						left: null,
						right: null,
						top: null
					};

					if ($el.hasClass('m1')) {
						const iright = ileft + elwidth;

						pos.left = 0;

						if (ileft - elwidth > 0) {
							if (iright > wx) {
								pos.left = null;
								pos.right = 0;
								pos.top = null;
							}
						}
					} else {
						const lc = ileft + elwidth * 2;

						pos.left = elwidth;
						pos.top = 0;

						if (wx < elwidth * 2 + 100) {
							pos.left = 0;
							pos.right = null;
							pos.top = $el.height();
						} else if (lc > wx) {
							pos.left = null;
							pos.right = elwidth;
							pos.top = null;
						}
					}

					$el.css({
						left: pos.left,
						right: pos.right,
						top: pos.top
					});

					$el.stop(true, true);
					$el.animate({ opacity: 'show', height: 'show' }, 150);
				});
			}

			function close($item) {
				$item.removeData('opened');

				$item.children('ul')
					.stop(true,true).delay(400)
					.animate({ opacity: 'hide', height: 'hide' }, 100);
			}

			function closeAll() {
				close($children);
			}

			$children.click(function (e) {
				var wx=$(window).width();
				var $this=$(this);

				if (wx<=700) {
					if (!$this.data('opened')) {
						e.preventDefault();

						open($this);
					}

					e.stopPropagation();
				}
			});

			$('body').click(function (e) {
				var wx=$(window).width();

				if (wx<=700) {
					closeAll();
				}
			});

			$children.hover(
				function() {
					var wx=$(window).width();

					if (wx>700) {
						open($(this));
					}
				},

				function() {
					var wx=$(window).width();

					if (wx>700) {
						close($(this));
					}

				}
			);
		}

		initMenu($('.mainmenu .children'));
		initHomeTimer();

		$('.js-topbutton').click(function(e) {
			e.preventDefault();

			var $this = $(this);

			(<any> $).fancybox({
				href: $this.data('url'),
				width: $this.data('width'),
				centerOnScroll: true
			});
		});

		$(window).resize(updateLayout);
		$(window).scroll(updateLayout);
		updateLayout();

		setTimeout(function() {
			$body.addClass('body--anim');
		}, 10);
	});

})(jQuery);

Site.init();
